import { Fragment } from 'react';
import { useParams } from 'react-router-dom';

import { formatDate } from 'lib/helpers/dateUtils';
import usePortalNavigate from 'lib/hooks/usePortalNavigate';

const AppointmentDetail = ({ activity, timezone }) => {
  const navigate = usePortalNavigate();
  const { id: patientId } = useParams();
  const { appointmentLink, appointmentDate, appointmentProvider } = activity;

  const handleClick = () => {
    if (appointmentLink && patientId) {
      navigate(`/portal/charts/${patientId}?appointment_id=${appointmentLink}`);
    }
  };

  const parts = [
    appointmentLink && (
      <span
        key="id"
        role="link"
        tabIndex={0}
        className="cursor-pointer text-primary-500 hover:underline"
        onClick={handleClick}
        onKeyDown={(e) => e.key === 'Enter' && handleClick()}>
        #{appointmentLink}
      </span>
    ),
    appointmentDate && (
      <span key="date">{formatDate(appointmentDate, timezone, 'MMM d, yyyy h:mma')}</span>
    ),
    appointmentProvider && <span key="provider">{appointmentProvider}</span>
  ].filter(Boolean);

  return (
    <div className="pl-[9px]">
      <div className="border-0 border-l border-solid border-neutral-300 pl-[13px] text-sm leading-[22px] text-neutral-600">
        {parts.map((part, i) => (
          <Fragment key={i}>
            {i > 0 && <span className="mx-1">·</span>}
            {part}
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default AppointmentDetail;
